import styles from './RoundIcon.module.scss';

function RoundIcon({
  bgColor,
  imgSrc,
  size = 'default',
  isTransparent = false,
  badgeCount = 0,
  borderColor = '',
}: {
  bgColor: string;
  imgSrc: string;
  size?: 'small' | 'default' | 'defaultFixed' | 'large';
  isTransparent?: boolean;
  badgeCount?: number;
  borderColor?: string;
}) {
  const generateContainerStyle = () => {
    const style = { backgroundColor: `var(--color-${bgColor})` };
    return borderColor ? { ...style, ...{ border: `1px solid var(--color-${borderColor})` } } : style;
  };
  return (
    <div className={styles.componentStyle}>
      <div
        className={`${styles[`${size}Container`]} ${isTransparent ? styles.transparentContainer : styles.commonContainer}`}
        style={generateContainerStyle()}
      >
        <img src={imgSrc} alt='icon' className={`${styles[`${size}Image`]}`} />
      </div>
      {badgeCount > 0 && (
        <div className={`${styles.countBadge} ${styles[`${size}Badge`]} ${badgeCount > 99 ? styles.badgeOver99 : ''}`}>
          {badgeCount > 99 ? '99+' : badgeCount}
        </div>
      )}
    </div>
  );
}

export default RoundIcon;
